import antdPt from "antd/lib/locale-provider/pt_PT";
import appLocaleData from "react-intl/locale-data/pt";
import enMessages from "../locales/en_US.json";
import ptMessages from "../locales/pt_PT.json";

const PtLang = {
  messages: {
    ...enMessages,
    ...ptMessages
  },
  antd: antdPt,
  locale: 'pt',
  data: appLocaleData
};
export default PtLang;
